import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Testimonials-slider-item-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "Testimonials-slider-item-icon",
  viewBox: "0 0 409 272",
  width: "406",
  height: "272",
  fill: "#000000",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M177.757 92.571h-17.203c-33.64 0-50.46 24.762-50.46 74.286V272H0V158.857c0-50.286 12.997-89.143 38.992-116.571C65.75 14.096 102.449 0 149.086 0h28.671v92.571ZM406 92.571h-17.202c-33.64 0-50.46 24.762-50.46 74.286V272H228.243V158.857c0-50.286 12.998-89.143 38.992-116.571C293.994 14.096 330.692 0 377.33 0H406v92.571Z" })
], -1)
const _hoisted_3 = { class: "Testimonials-slider-item-inner" }
const _hoisted_4 = { class: "Testimonials-slider-item-text h4" }
const _hoisted_5 = { class: "carousel-cell Testimonials-slider-item-legend" }
const _hoisted_6 = { class: "Testimonials-slider-item-legend-img" }
const _hoisted_7 = ["srcset"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "h5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "Testimonials-drag" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "21",
    height: "8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.146 4.036a.5.5 0 0 1 0-.708L3.328.146a.5.5 0 1 1 .708.708L1.707 3.182h17.586L16.965.854a.5.5 0 1 1 .707-.708l3.182 3.182a.5.5 0 0 1 0 .708l-3.182 3.182a.5.5 0 1 1-.707-.708l2.328-2.328H1.707L4.036 6.51a.5.5 0 1 1-.708.708L.146 4.036Z",
      fill: "#000"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_CursorFollow = _resolveComponent("CursorFollow")!
  const _component_RoundSection = _resolveComponent("RoundSection")!
  const _component_AppearObject = _resolveComponent("AppearObject")!

  return (_openBlock(), _createBlock(_component_AppearObject, {
    class: _normalizeClass(`Testimonials Testimonials--${_ctx.backgroundColor}`),
    "data-scroll-section": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_RoundSection, { class: "Testimonials-inner" }, {
        default: _withCtx(() => [
          _createVNode(_component_CursorFollow, null, {
            cursor: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Slider, {
                ref: "slider",
                onDragStart: _ctx.onDragStart,
                autoPlay: true,
                class: "Testimonials-slider"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "Testimonials-slider-item"
                    }, [
                      _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("figure", _hoisted_3, [
                          _createElementVNode("blockquote", _hoisted_4, [
                            _createVNode(_component_LineByLine, {
                              innerHTML: item.text
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createElementVNode("figcaption", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("picture", null, [
                                _createElementVNode("source", {
                                  srcset: `/images/home/${item.picture}.jpg 1x, /images/home/${item.picture}@2x.jpg 2x`
                                }, null, 8, _hoisted_7),
                                _createElementVNode("img", {
                                  src: `/images/home/${item.picture}.jpg`,
                                  alt: item.name
                                }, null, 8, _hoisted_8)
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.name) + ", " + _toDisplayString(item.position) + ", " + _toDisplayString(item.place), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onDragStart"])
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrev && _ctx.onPrev(...args))),
            type: "button",
            class: "Testimonials-prev"
          }),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args))),
            type: "button",
            class: "Testimonials-next"
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}